import * as zod from 'zod';

// Else has no condition - it runs if all previous If/ElseIf conditions were false
export default zod.object({});
